export default __webpack_public_path__ + "static/media/Group 5629.dc600874.svg";